import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { getter, Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  // GridFilterChangeEvent,
  // GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridSelectionChangeEvent,
  GridHeaderSelectionChangeEvent,
  getSelectedState,
  GridCellProps,
} from "@progress/kendo-react-grid";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import ShadowCard from "../../components/common/ShadowCard";
import FormSwitchField from "../../components/formFields/FormSwitchField";
import FormMultiSelectionFiled from "../../components/formFields/FormMultiSelectionFiled";
import { IUser } from "../user/userModel";
import { getAllActiveUsers } from "../user/services/user.services";
import { Button } from "@progress/kendo-react-buttons";
import {
  deleteAutoLeadAssignSetting,
  getAllAutoLeadAssigns,
  getLeadAssignSettings,
  insertAutoLeadAssignSetting,
  updateAutoLeadAssign,
} from "./services/leadAssignSetting.services";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  clearLeadAssignEmployeeID,
  setLeadAssignEmployeeID,
} from "./leadAssignSettingSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";

const LeadAssignSetting: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const [formKey, setFormKey] = useState(1);

  const loading = useAppSelector((state) => state.leadAssignSetting.loading);
  const UserList = useAppSelector((state) => state.user.UserList);
  const LeadAssignSettingDetails = useAppSelector(
    (state) => state.leadAssignSetting.LeadAssignSettingDetails
  );
  const LeadAssignEmployeeList = useAppSelector(
    (state) => state.leadAssignSetting.LeadAssignEmployeeList
  );
  const dataState = LeadAssignEmployeeList?.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem)
  );

  const DATA_ITEM_KEY: string = "ID";
  const idGetter = getter(DATA_ITEM_KEY);
  const [leadAssignEmploeeData, setLeadAssignEmploeeData] = useState<any[]>([]);
  const [selectedState, setSelectedState] = React.useState<{
    [id: string]: boolean | number[];
  }>({});
  const [rowSelectionModel, setRowSelectionModel] = React.useState<number[]>(
    []
  );

  useEffect(() => {
    setLeadAssignEmploeeData(LeadAssignEmployeeList || []);
  }, [LeadAssignEmployeeList]);

  useEffect(() => {
    dispatch(getLeadAssignSettings());
    dispatch(getAllAutoLeadAssigns());
    dispatch(getAllActiveUsers());
  }, []);

  // useEffect(() => {
  //   if (
  //     LeadAssignSettingDetails &&
  //     LeadAssignSettingDetails?.LeadAutoAssign &&
  //     LeadAssignEmployeeList?.length > 0
  //   ) {
  //     setSelectedState(
  //       LeadAssignEmployeeList?.map((s: any) => s?.ID).reduce(
  //         (acc: any, code: any) => {
  //           acc[code] = true;
  //           return acc;
  //         },
  //         {}
  //       )
  //     );
  //     setRowSelectionModel(
  //       LeadAssignEmployeeList?.map((e: any) => +e?.ID) || []
  //     );
  //   }
  // }, [LeadAssignSettingDetails?.LeadAutoAssign, LeadAssignEmployeeList]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [LeadAssignSettingDetails]);

  const onSelectionChange = React.useCallback(
    (event: GridSelectionChangeEvent) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });
      setSelectedState(newSelectedState);
      const trueKeys = Object.keys(newSelectedState)
        .filter((key) => newSelectedState[key])
        .map(Number);
      setRowSelectionModel(trueKeys);
    },
    [selectedState]
  );
  const onHeaderSelectionChange = React.useCallback(
    (event: GridHeaderSelectionChangeEvent) => {
      const checkboxElement: any = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState: { [key: string]: boolean } = {};

      event.dataItems.forEach((item) => {
        newSelectedState[idGetter(item)] = checked;
      });
      setSelectedState(newSelectedState);
      const trueKeys = Object.keys(newSelectedState)
        .filter((key: string) => newSelectedState[key])
        .map(Number);
      setRowSelectionModel(trueKeys);
    },
    []
  );
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 0 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const handleOpenDeleteDialog = (ID: string) => {
    dispatch(openDialog("deleteLeadAssignEmployee"));
    dispatch(setLeadAssignEmployeeID(ID));
  };
  const MyEditCommandCell = (props: GridCellProps) => {
    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          className="color-red"
          onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          icon={MdDelete}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
      </td>
    );
  };

  const handleEmployeeSet = async (formRenderProps: FormRenderProps) => {
    const EmployeeID = formRenderProps.valueGetter("EmployeeID");
    if (EmployeeID?.length > 0) {
      const res = await dispatch(
        insertAutoLeadAssignSetting({
          EmployeeID: EmployeeID?.join(","),
        })
      );
      if (res.meta?.requestStatus === "fulfilled") {
        setSelectedState({});
        setRowSelectionModel([]);
        dispatch(getAllAutoLeadAssigns());
      }
    }
  };
  const handleChangeLeadStatus = async (payload: any) => {
    const res = await dispatch(updateAutoLeadAssign(payload));
    if (res.meta?.requestStatus === "fulfilled") {
      dispatch(getLeadAssignSettings());
      dispatch(getAllAutoLeadAssigns());
      setSelectedState({});
      setRowSelectionModel([]);
    }
  };

  const handleSubmit = async () => {
    // try {
    //   const payload = {
    //     TCSUnderPer: values.TCSUnderPer,
    //     TCSLimit: values.TCSLimit,
    //     TCSOverPer: values.TCSOverPer,
    //     GST: values.GST,
    //     Dom_Quot_TermsNCondition: values?.Dom_Quot_TermsNCondition,
    //     Int_Quot_TermsNCondition: values?.Int_Quot_TermsNCondition,
    //     Dom_FIT_TermsNCondition: values?.Dom_FIT_TermsNCondition,
    //     Int_FIT_TermsNCondition: values?.Int_FIT_TermsNCondition,
    //   };
    //   const response = await dispatch(updateLeadAssignSettings(payload));
    //   if (response?.meta?.requestStatus === "fulfilled") {
    //     dispatch(getLeadAssignSettings());
    //   }
    // } catch (error) {
    //   console.error("Error in handleSubmit:", error);
    //   throw error;
    // }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <DeleteAssignedEmployeeDialog
        setSelectedState={setSelectedState}
        setRowSelectionModel={setRowSelectionModel}
      />
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={LeadAssignSettingDetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <Typography.h4>{"Lead Assign Setting"}</Typography.h4>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h5 className="d-flex justify-content-between align-items-center mx-2">
                    <Field
                      wrapperStyle={{ marginTop: 10 }}
                      name="LeadAutoAssign"
                      label="Lead Auto Assign"
                      component={FormSwitchField}
                      astrike={true}
                      onChange={(e: any) => {
                        handleChangeLeadStatus({
                          LeadAutoAssign: e?.value,
                          SectorWiseAssign:
                            formRenderProps.valueGetter("SectorWiseAssign"),
                        });
                      }}
                    />
                    <Field
                      wrapperStyle={{ marginTop: 10 }}
                      name="SectorWiseAssign"
                      label="Sector Wise Assign"
                      component={FormSwitchField}
                      astrike={true}
                      onChange={(e: any) => {
                        handleChangeLeadStatus({
                          SectorWiseAssign: e?.value,
                          LeadAutoAssign:
                            formRenderProps.valueGetter("LeadAutoAssign"),
                        });
                      }}
                    />
                  </Typography.h5>
                  {rowSelectionModel && rowSelectionModel?.length > 0 ? (
                    <IconButton
                      type="button"
                      fillMode="flat"
                      size="small"
                      title="Delete"
                      className="color-red"
                      onClick={() =>
                        handleOpenDeleteDialog(
                          rowSelectionModel ? rowSelectionModel?.join(", ") : ""
                        )
                      }
                      icon={MdDelete}
                      iconClassName="absolute-position"
                      iconStyle={{ fontSize: "24px" }}
                    />
                  ) : null}
                </GridLayoutItem>
                {(formRenderProps.valueGetter("LeadAutoAssign") ||
                  formRenderProps.valueGetter("SectorWiseAssign")) &&
                leadAssignEmploeeData &&
                leadAssignEmploeeData?.length > 0 ? (
                  <>
                    <GridLayoutItem
                      className="pt-2"
                      style={{
                        borderTop: "1px solid lightgray",
                      }}
                      colSpan={3}
                    >
                      <Typography.h6 className="mb-0">
                        {"Auto Assigned Employee"}
                      </Typography.h6>
                    </GridLayoutItem>
                    <GridLayoutItem
                      className="mt-2"
                      style={{ position: "relative" }}
                      colSpan={3}
                    >
                      <KendoGrid
                        style={{ maxHeight: "304px" }}
                        filterable={false}
                        // filter={filter}
                        dataItemKey={DATA_ITEM_KEY}
                        data={
                          // filter
                          //   ? filterBy(leadAssignEmploeeData, filter).slice(
                          //       page.skip,
                          //       page.take + page.skip
                          //     )
                          //   :
                          leadAssignEmploeeData
                        }
                        // onFilterChange={handleFilterChange}
                        selectable={true}
                        select={selectedState}
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                        // skip={page.skip}
                        // take={page.take}
                        total={leadAssignEmploeeData.length}
                        // pageable={{
                        //   buttonCount: 5,
                        //   pageSizes: [5, 10, 15, "All"],
                        //   pageSizeValue: pageSizeValue,
                        //   type: "input",
                        // }}
                        // onPageChange={pageChange}
                        cells={{
                          headerCell: HeaderCustomCell,
                          data: MyDataCustomCell,
                        }}
                        // className="responsive-table"
                      >
                        <Column
                          filterable={false}
                          columnType="checkbox"
                          width={50}
                          locked={true}
                          headerSelectionValue={
                            dataState?.findIndex(
                              (item: any) => !selectedState[idGetter(item)]
                            ) === -1
                          }
                        />
                        <Column
                          field="EmployeeName"
                          title="Employee Name"
                          // width={150}
                        />
                        <Column
                          field="ID"
                          title="Actions"
                          cells={{ data: MyEditCommandCell }}
                          width={90}
                          filterable={false}
                        />
                      </KendoGrid>
                    </GridLayoutItem>
                  </>
                ) : null}
                {(formRenderProps.valueGetter("LeadAutoAssign") ||
                  formRenderProps.valueGetter("SectorWiseAssign")) && (
                  <>
                    <GridLayoutItem className="mt-4">
                      <Typography.h6 className="mb-0">
                        {"Select Employee for Auto Assign"}
                      </Typography.h6>
                      <Field
                        wrapperClassName="mt-1"
                        id={"EmployeeID"}
                        name={"EmployeeID"}
                        label={""}
                        placeholder="Employee"
                        component={FormMultiSelectionFiled}
                        options={UserList?.map((user: IUser) => {
                          return {
                            value: user?.ID,
                            label: `${user?.FirstName} ${user?.LastName}`,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Button
                        type="button"
                        themeColor="primary"
                        fillMode={"solid"}
                        style={{ marginTop: 48 }}
                        disabled={
                          formRenderProps.valueGetter("EmployeeID")?.length < 1
                        }
                        onClick={() => handleEmployeeSet(formRenderProps)}
                      >
                        Set
                      </Button>
                    </GridLayoutItem>
                  </>
                )}
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

const DeleteAssignedEmployeeDialog = ({
  setSelectedState,
  setRowSelectionModel,
}: {
  setSelectedState: any;
  setRowSelectionModel: any;
}) => {
  const dispatch = useAppDispatch();
  const LeadAssignEmployeeID = useAppSelector(
    (state) => state.leadAssignSetting.LeadAssignEmployeeID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: string) => {
    if (ID) {
      const response = await dispatch(deleteAutoLeadAssignSetting(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(getAllAutoLeadAssigns());
        dispatch(closeDialog());
        dispatch(clearLeadAssignEmployeeID());
        setSelectedState({});
        setRowSelectionModel([]);
      } else {
        dispatch(getAllAutoLeadAssigns());
        dispatch(closeDialog());
        dispatch(clearLeadAssignEmployeeID());
        setSelectedState({});
        setRowSelectionModel([]);
      }
    }
  };

  return (
    <>
      {dialogName === "deleteLeadAssignEmployee" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Assigned Employee"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Assigned Employee?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(LeadAssignEmployeeID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default LeadAssignSetting;
